import { render } from "./DocEdit.vue?vue&type=template&id=8420c4ec"
import script from "./DocEdit.vue?vue&type=script&lang=js"
export * from "./DocEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__